import { useIntl } from 'react-intl'
import { colors, fonts } from 'app-v2/design-systems'
import { BORDER, SPACING } from 'app-v2/design-tokens'
import React from 'react'
import { H2, H3, Text } from 'app/common/typography'
//$FlowFixMe
import buoy from 'app/tu-preferes-king/assets/bouée.webp'
import {
    Borne,
    Chevalet,
    ClickAndCollectBagClick,
    Drive
} from '../../../../assets/icons'
import { useWindowDimensions } from '../../../utils'
import { breakpoints } from '../../../../assets/styles'
import styled from 'styled-components'
import { media } from '../../../../assets/styles'
import { TPKColors } from '../../../colors'
import { ExplanationItem } from './ExplanationItem'
import { Item } from './Item'

export const ExplanationsToClaim = () => {
    const intl = useIntl()
    const { width: windowWidth } = useWindowDimensions()
    const isSmall = windowWidth <= breakpoints.small
    const Title = isSmall ? H2 : H3
    return (
        <StyledMainContainer>
            <StyledCard>
                <StyledTitleContainer>
                    <Title font={fonts.flameBold}>
                        {intl.formatMessage({
                            id: isSmall
                                ? 'tupreferesking.home.explanation.title'
                                : 'tupreferesking.home.explanation.desktop.title'
                        })}
                    </Title>
                    <StyledBuoyContainer>
                        <img src={buoy} alt={'buoy'} />
                    </StyledBuoyContainer>
                    <Text font={fonts.flameSansRegular}>
                        {intl.formatMessage({
                            id: 'tupreferesking.home.explanation.description'
                        })}
                    </Text>
                </StyledTitleContainer>
                <ExplanationItem
                    title={
                        <StyledTextContainer>
                            <Borne size={32} />
                            <Text font={fonts.flameRegular} size={SPACING.M}>
                                {intl.formatMessage({
                                    id:
                                        'tupreferesking.home.explanation.borne.title'
                                })}
                            </Text>
                        </StyledTextContainer>
                    }>
                    <Item>
                        <StyledExplanation>
                            <StyledPoint></StyledPoint>
                            <StyledExplainationTextContainer>
                                <Text font={fonts.flameSansRegular}>
                                    {intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanation.borne.text.2'
                                    })}
                                </Text>
                            </StyledExplainationTextContainer>
                        </StyledExplanation>
                        <StyledExplanation>
                            <StyledPoint></StyledPoint>
                            <StyledExplainationTextContainer>
                                <Text font={fonts.flameSansRegular}>
                                    {intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanation.borne.text.3'
                                    })}
                                </Text>
                            </StyledExplainationTextContainer>
                        </StyledExplanation>
                    </Item>
                </ExplanationItem>

                <ExplanationItem
                    title={
                        <StyledTextContainer>
                            <Drive size={32} color={colors.bbqBrown} />
                            <Text font={fonts.flameRegular} size={SPACING.M}>
                                {intl.formatMessage({
                                    id:
                                        'tupreferesking.home.explanation.drive.title'
                                })}
                            </Text>
                        </StyledTextContainer>
                    }>
                    <Item>
                        <StyledExplanation>
                            <StyledPoint></StyledPoint>
                            <StyledExplainationTextContainer>
                                <Text font={fonts.flameSansRegular}>
                                    {intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanation.drive.text.2'
                                    })}
                                </Text>
                            </StyledExplainationTextContainer>
                        </StyledExplanation>
                        <StyledExplanation>
                            <StyledPoint></StyledPoint>
                            <StyledExplainationTextContainer>
                                <Text font={fonts.flameSansRegular}>
                                    {intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanation.drive.text.3'
                                    })}
                                </Text>
                            </StyledExplainationTextContainer>
                        </StyledExplanation>
                    </Item>
                </ExplanationItem>

                <ExplanationItem
                    title={
                        <StyledTextContainer>
                            <ClickAndCollectBagClick
                                size={32}
                                color={colors.bbqBrown}
                            />
                            <Text font={fonts.flameRegular} size={SPACING.M}>
                                {intl.formatMessage({
                                    id:
                                        'tupreferesking.home.explanation.cc.title'
                                })}
                            </Text>
                        </StyledTextContainer>
                    }>
                    <Item>
                        <StyledExplanation>
                            <StyledPoint></StyledPoint>
                            <StyledExplainationTextContainer>
                                <Text font={fonts.flameSansRegular}>
                                    {intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanation.cc.text.2'
                                    })}
                                </Text>
                            </StyledExplainationTextContainer>
                        </StyledExplanation>
                        <StyledExplanation>
                            <StyledPoint></StyledPoint>
                            <StyledExplainationTextContainer>
                                <Text font={fonts.flameSansRegular}>
                                    {intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanation.cc.text.3'
                                    })}
                                </Text>
                            </StyledExplainationTextContainer>
                        </StyledExplanation>
                        <StyledExplanation>
                            <StyledPoint></StyledPoint>
                            <StyledExplainationTextContainer>
                                <Text font={fonts.flameSansRegular}>
                                    {intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanation.cc.text.4'
                                    })}
                                </Text>
                            </StyledExplainationTextContainer>
                        </StyledExplanation>
                    </Item>
                </ExplanationItem>

                <ExplanationItem
                    title={
                        <StyledTextContainer>
                            <Chevalet size={32} color={colors.bbqBrown} />
                            <Text font={fonts.flameRegular} size={SPACING.M}>
                                {intl.formatMessage({
                                    id:
                                        'tupreferesking.home.explanation.kingtable.title'
                                })}
                            </Text>
                        </StyledTextContainer>
                    }>
                    <Item>
                        <StyledExplanation>
                            <StyledPoint></StyledPoint>
                            <StyledExplainationTextContainer>
                                <Text font={fonts.flameSansRegular}>
                                    {intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanation.kingtable.text.2'
                                    })}
                                </Text>
                            </StyledExplainationTextContainer>
                        </StyledExplanation>
                        <StyledExplanation>
                            <StyledPoint></StyledPoint>
                            <StyledExplainationTextContainer>
                                <Text font={fonts.flameSansRegular}>
                                    {intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanation.kingtable.text.3'
                                    })}
                                </Text>
                            </StyledExplainationTextContainer>
                        </StyledExplanation>
                        <StyledExplanation>
                            <StyledPoint></StyledPoint>
                            <StyledExplainationTextContainer>
                                <Text font={fonts.flameSansRegular}>
                                    {intl.formatMessage({
                                        id:
                                            'tupreferesking.home.explanation.kingtable.text.4'
                                    })}
                                </Text>
                            </StyledExplainationTextContainer>
                        </StyledExplanation>
                    </Item>
                </ExplanationItem>
            </StyledCard>
        </StyledMainContainer>
    )
}

const StyledTextContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${SPACING.XS};
    align-items: center;
`

const StyledExplanation = styled.div`
    border-left: 1px solid
        ${props => (props.end ? colors.white : TPKColors.explanationBlue)};
    display: flex;
    flex-direction: row;
    padding-left: ${SPACING.S};
    padding-bottom: ${SPACING.L};
`

const StyledPoint = styled.div`
    background-color: ${TPKColors.explanationBlue};
    border-radius: 50%;
    height: ${SPACING.XXS};
    width: ${SPACING.XXS};
    position: absolute;
    left: -${SPACING.XXXS};
`

const StyledExplainationTextContainer = styled.div`
    margin-top: -${SPACING.XXXS};
`

const StyledMainContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: ${SPACING.M};
`
const StyledCard = styled.div`
    background-color: ${colors.white};
    border-radius: ${BORDER.RADIUS.XL};
    padding: ${SPACING.XL};
    ${media.medium`padding: 48px;`}
    display: flex;
    flex-direction: column;
    gap: ${SPACING.S};
    ${media.medium`gap: ${SPACING.L};`}
    position: relative;
    max-width: 850px;
    align-self: center;
`

const StyledTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${SPACING.XS};
    ${media.medium`align-items: center;`}
`

const StyledBuoyContainer = styled.div`
    display: flex;
    position: absolute;
    flex: 1;
    z-index: 1;
    right: 0;
    top: 0;
    img {
        position: absolute;
        right: -${SPACING.M};
        top: -${SPACING.XL};
        height: 84px;
    }
`
